export const JOB_TYPES: Record<string, string> = {
  NMP: "Noise Mitigation Plan",
  AMB: "Ambient Monitoring",
  NIA: "Noise Impact Assessment",
  SIG: "Signal",
  CR: "Construction Review",
  CM: "Construction Monitoring",
};

export const CATEGORIES: Record<string, { label: string; subs: string[] }> = {
  NMP: {
    label: "Noise Mitigation Plan",
    subs: ["Preliminary", "Data Collection", "Analysis", "Report", "Revisions", "Client Review"],
  },
  AMB: {
    label: "Ambient Monitoring",
    subs: ["Setup", "Monitoring", "Data Processing", "Report", "Revisions"],
  },
  NIA: {
    label: "Noise Impact Assessment",
    subs: ["Preliminary", "Site Visit", "Analysis", "Report", "Revisions"],
  },
  SIG: { label: "Signal", subs: ["Design", "Review", "Revisions"] },
  CR: { label: "Construction Review", subs: ["Site Visit", "Documentation", "Report"] },
  CM: {
    label: "Construction Monitoring",
    subs: ["Mobilization", "Monitoring", "Data Processing", "Report"],
  },
};

interface OverheadItem {
  code: string;
  name: string;
  subs?: string[];
}

export const OVERHEAD: OverheadItem[] = [
  { code: "A001", name: "Company / General" },
  {
    code: "A002",
    name: "Business Development",
    subs: ["BD Events / New Sales Support", "Proposals"],
  },
  {
    code: "A003",
    name: "Professional Development",
    subs: ["Training", "Conferences", "Certifications"],
  },
  { code: "A004", name: "HR / Admin" },
  { code: "A005", name: "IT / Systems" },
  { code: "A006", name: "Facilities" },
  { code: "A007", name: "Finance / Accounting" },
  { code: "A008", name: "Legal" },
  { code: "A009", name: "Marketing" },
  { code: "A010", name: "Travel (Non-Billable)" },
  { code: "A011", name: "Project Management (Internal)" },
  { code: "A012", name: "QC / Review (Internal)" },
  { code: "A013", name: "Safety" },
  { code: "A014", name: "Meetings (Internal)" },
  { code: "A015", name: "Other Overhead" },
];
